import { AxiosInstance } from './axios.core';

import { API_URL } from './api.base';
import { CancelToken } from 'axios';

import { ListResponseModel, ListRuquestModel, OrganizationNodepProps } from './models'

export const getCSR = (): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/apns/plist`, {});
}


export const uploadCertificate = (certificate: any): Promise<any> => {
  const params = new FormData();
  params.append('certificate', certificate);

  return AxiosInstance.put(
    `${API_URL}/apns/certificate/upload`,
    params,
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
};

export const deleteCertificate = (): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/apns/certificate`)
}

export const postAppleID = (appleId: string): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/apns/certificate/${appleId}`, {});
}

export const getAPNDetail = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/apns/detail`, {});
}

export const getMobileConfig = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/apns/mobileconfig`, {});
}

export const postIOSEnroll = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/apns/iosenroll`, {});
}
export const getIosScanCodeSrc = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/apns/mobileconfig/orcode`, {});
}
export const getAbmDevices = (params:any): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/abm/dep/devices`,{params});
}
export const setAbmDevices = (params:any[]): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/abm/dep/profile/assign`, params);
}
export const setAbmDevicesAll = (): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/abm/dep/profile/assign/all`);
}

export const getSkipsteps = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/abm/activation`);
}

export const addSkipsteps = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/abm/activation/set`, params);
}

export const getMacOSMobileconfig = (companyId :any)=>{
  return `${API_URL}/apns/mobileconfig/macos?companyId=${companyId}`;
}
export const getMobileconfig = (companyId :any)=>{
  return `${API_URL}/apns/mobileconfig?companyId=${companyId}`;
}

// export const  getIosScanCodeSrc  =`${API_URL}/apns/iosenroll/${oid}/${comId}`;

export const deleteMacEnrollmentSetting = (settingId: string): Promise<any> => {
  return AxiosInstance.delete(`${API_URL}/enrollmentSettings/${settingId}/`);
}

export const addOrUpdateMacEnrollmentSettingBasicInfo = (params: any): Promise<any> => {
  return AxiosInstance.put(`${API_URL}/enrollmentSettings/basicInfo`, params);
}

export const getMacEnrollmentSetting = (settingId: string): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/enrollmentSettings/${settingId}`);
}

export const updateMacEnrollmentSettingAccountInfo = (settingId: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/enrollmentSettings/${settingId}/accountInfo`, params);
}

export const getMacEnrollmentSettingList = (params: ListRuquestModel): Promise<ListResponseModel<any>> => {
  return AxiosInstance.get(`${API_URL}/enrollmentSettings`, { params });
}

export const updateMacEnrollmentSettingCustomWeb = (settingId: string, params: any): Promise<any> => {
  return AxiosInstance.post(`${API_URL}/enrollmentSettings/${settingId}/customWebSetting`, params);
}

export const getSettingWiFiList = (): Promise<any> => {
  return AxiosInstance.get(`${API_URL}/enrollmentSettings/wifis`);
}